<div class="alert alert-info" [class.default]="isDefault" [class.lightblue]="isLightblue">
    <i *ngIf="faIcon" [class]="faIcon" [ngStyle]="{color: iconColor}"></i>
    <span [i18n]="[{target: 'innerHTML', key: i18nkey}]"></span>
</div>
